import React from 'react'
import {createStyles, makeStyles, Theme} from "@material-ui/core"
import { AvantColors } from "../../../../../../styles/AvantColors"
import {OVERALL_DISPLAY_HEIGHT, SKILL_TRIANGLE_ORIGIN_X} from "./SkillTriangleUtils"

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backgroundLines: {
            // Grey Background lines
            stroke: AvantColors.REPORT_FONT_COLOR_GRAY_3,
            strokeWidth: 1
        },
        backgroundRect: {
            fill: "#FAFAFA",
            // fill: "#000000"
        },
        imageText: {
            fontFamily: "sans-serif",
            fontSize: "24px",
            fill: AvantColors.REPORT_FONT_COLOR_GRAY_3,
        },
    }),
)

const TEXT_X_OFFSET = 10
const TEXT_Y_OFFSET = 30
const HEIGHT_OFFSET = 10
const NOV_STRIATION_TOP_BOARDER = (5 * (OVERALL_DISPLAY_HEIGHT) / 7) + 4.5
const NOV_TEXT_Y_LOCATION = (((OVERALL_DISPLAY_HEIGHT) - NOV_STRIATION_TOP_BOARDER) / 2) + NOV_STRIATION_TOP_BOARDER + HEIGHT_OFFSET + TEXT_Y_OFFSET
const INT_TEXT_Y_LOCATION = ((NOV_STRIATION_TOP_BOARDER) / 2) + HEIGHT_OFFSET + TEXT_Y_OFFSET

export const TwoStriationSkillTriangleBackground: React.FC = () => {

    const classes = useStyles()

    return (
        <>
            <rect
                id={"novice-range-striation-box"}
                x={SKILL_TRIANGLE_ORIGIN_X}
                y={NOV_STRIATION_TOP_BOARDER}
                width={"100%"}
                height={OVERALL_DISPLAY_HEIGHT - NOV_STRIATION_TOP_BOARDER + NOV_STRIATION_TOP_BOARDER}
                className={classes.backgroundRect}
            />
            <text
                id={"intermediate-level-range-text"}
                x={TEXT_X_OFFSET}
                y={INT_TEXT_Y_LOCATION}
                className={classes.imageText}
            >
                INT
            </text>
            <text
                id={"novice-level-range-text"}
                x={TEXT_X_OFFSET}
                y={NOV_TEXT_Y_LOCATION}
                className={classes.imageText}
            >
                NOV
            </text>
            <line
                x1={SKILL_TRIANGLE_ORIGIN_X}
                y1={"55"}
                x2={"100%"}
                y2={"55"}
                className={classes.backgroundLines}
            />
            <line
                id={"novice-level-striation-top-border"}
                x1={SKILL_TRIANGLE_ORIGIN_X}
                y1={NOV_STRIATION_TOP_BOARDER}
                x2={"100%"}
                y2={NOV_STRIATION_TOP_BOARDER}
                className={classes.backgroundLines}
            />
            <line
                x1={SKILL_TRIANGLE_ORIGIN_X}
                y1={"405"}
                x2={"100%"}
                y2={"405"}
                className={classes.backgroundLines}
            />
        </>
    )


}
